module.exports = __webpack_public_path__ + "static/media/C006.e5554182.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C006.jpg
// module id = 289
// module chunks = 0